export const ProfileIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 6C12.5 7.38071 11.3807 8.5 10 8.5C8.61929 8.5 7.5 7.38071 7.5 6C7.5 4.61929 8.61929 3.5 10 3.5C11.3807 3.5 12.5 4.61929 12.5 6ZM12.6109 9.03048C13.4615 8.29695 14 7.21136 14 6C14 3.79086 12.2091 2 10 2C7.79086 2 6 3.79086 6 6C6 7.21136 6.53847 8.29695 7.38911 9.03048C4.81629 10.0654 3 12.5843 3 15.5273C3 15.6495 3.00313 15.7708 3.0093 15.8914C3.02802 16.2568 3.34241 16.5258 3.70824 16.5258C4.16732 16.5258 4.51129 16.1081 4.50132 15.6491C4.50044 15.6086 4.5 15.568 4.5 15.5273C4.5 12.4898 6.96243 10.0273 10 10.0273C13.0376 10.0273 15.5 12.4898 15.5 15.5273C15.5 15.568 15.4996 15.6086 15.4987 15.6491C15.4887 16.1081 15.8327 16.5258 16.2918 16.5258C16.6576 16.5258 16.972 16.2568 16.9907 15.8914C16.9969 15.7708 17 15.6495 17 15.5273C17 12.5843 15.1837 10.0654 12.6109 9.03048Z"
        fill="#3E3E3E"
      />
    </svg>
  )
}
